import React, { useEffect, useState, useContext } from 'react';
import { VisibilityContext } from "react-horizontal-scrolling-menu";
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5'
import { DiseaseGroupContext } from '../../contexts/diseaseGroupContext';

export const ScrollButton = ({ children, direction }) => {

    const { isFirstItemVisible, isLastItemVisible, scrollPrev, scrollNext, visibleItemsWithoutSeparators } = useContext(VisibilityContext);

    let scroll, isItemVisible, gradientDirection;

    const { theme } = useContext(DiseaseGroupContext);

    switch (direction.toLowerCase()) {
        case "left":
            scroll = scrollPrev;
            isItemVisible = isFirstItemVisible;
            gradientDirection = "bg-gradient-to-r"
            break;
        case "right":
            scroll = scrollNext;
            isItemVisible = isLastItemVisible;
            gradientDirection = "bg-gradient-to-l"
            break;
    }

    const [disabled, setDisabled] = useState(!visibleItemsWithoutSeparators.length && isItemVisible);

    useEffect(() => {
        if (visibleItemsWithoutSeparators.length) {
            setDisabled(isItemVisible);
        }

    }, [isItemVisible, visibleItemsWithoutSeparators])

    if (disabled === true) {
        return null;
    }

    const themePrimary = theme.primary();

    return (
        <button className={`w-14 xs:w-16 absolute ${direction}-0 z-20 h-full ${themePrimary.from()} ${themePrimary.via()} ${gradientDirection} pb-6`} disabled={disabled}
            onClick={() => { scroll(); }}
        >
            {children}
        </button>
    );
}

export const LeftScroll = () => {
    return <ScrollButton direction={"left"}><IoChevronBackOutline className={"mx-auto text-xl xs:text-3xl"} /></ScrollButton>
}

export const RightScroll = () => {
    return <ScrollButton direction={"right"}><IoChevronForwardOutline className={"mx-auto text-xl xs:text-3xl"} /></ScrollButton>
}
